// import Cookies from 'js-cookie';
import Base64 from 'crypto-js/enc-base64';
import sha256 from 'crypto-js/sha256';
const TokenKey = 'vue_admin_template_token-management';

export function getToken() {
  // return Cookies.get(TokenKey);
  return localStorage.getItem(TokenKey);
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token);
  return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  // return Cookies.remove(TokenKey);
  return localStorage.setItem(TokenKey, '');
}

/**
 * @description 获取加密签名和时间戳
 * @param token
 * @returns {{timestamp: string, signature: string}}
 */
export function createSignature(token) {
  console.log(token, 'token');
  // 生成当前UTC时间戳并格式化为ISO8601字符串
  const timestamp = new Date().toISOString();

  // 构建明文: token + "\n" + timestamp
  const plainText = token + '\n' + timestamp;

  // 生成SHA-256哈希并转换为Base64编码
  const hash = sha256(plainText);
  const signature = Base64.stringify(hash);

  // 返回timestamp和Base64编码签名
  return {
    timestamp: timestamp,
    signature: signature
  };
}
